"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WS = void 0;

var _utils = require("../utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Whitespace modifiers to be used with add() method */
var WS;
exports.WS = WS;

(function (WS) {
  WS[WS["SPACE"] = 0] = "SPACE";
  WS[WS["NO_SPACE"] = 1] = "NO_SPACE";
  WS[WS["NEWLINE"] = 2] = "NEWLINE";
  WS[WS["INDENT"] = 3] = "INDENT";
  WS[WS["SINGLE_INDENT"] = 4] = "SINGLE_INDENT";
})(WS || (exports.WS = WS = {}));

/**
 * API for constructing SQL string (especially the whitespace part).
 *
 * It hides the internal implementation.
 * Originally it used plain string concatenation, which was expensive.
 * Now it's storing items to array and builds the string only in the end.
 */
var Layout = /*#__PURE__*/function () {
  function Layout(indentation) {
    _classCallCheck(this, Layout);

    this.indentation = indentation;

    _defineProperty(this, "items", []);
  }
  /**
   * Appends token strings and whitespace modifications to SQL string.
   */


  _createClass(Layout, [{
    key: "add",
    value: function add() {
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }

      for (var _i = 0, _items = items; _i < _items.length; _i++) {
        var item = _items[_i];

        switch (item) {
          case WS.SPACE:
            this.items.push(WS.SPACE);
            break;

          case WS.NO_SPACE:
            this.trimHorizontalWhitespace();
            break;

          case WS.NEWLINE:
            this.trimHorizontalWhitespace();
            this.addNewline();
            break;

          case WS.INDENT:
            this.addIndentation();
            break;

          case WS.SINGLE_INDENT:
            this.items.push(WS.SINGLE_INDENT);
            break;

          default:
            this.items.push(item);
        }
      }
    }
  }, {
    key: "trimHorizontalWhitespace",
    value: function trimHorizontalWhitespace() {
      while (isHorizontalWhitespace((0, _utils.last)(this.items))) {
        this.items.pop();
      }
    }
  }, {
    key: "addNewline",
    value: function addNewline() {
      if (this.items.length > 0 && (0, _utils.last)(this.items) !== WS.NEWLINE) {
        this.items.push(WS.NEWLINE);
      }
    }
  }, {
    key: "addIndentation",
    value: function addIndentation() {
      for (var i = 0; i < this.indentation.getLevel(); i++) {
        this.items.push(WS.SINGLE_INDENT);
      }
    }
    /**
     * Returns the final SQL string.
     */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return this.items.map(function (item) {
        return _this.itemToString(item);
      }).join('');
    }
  }, {
    key: "itemToString",
    value: function itemToString(item) {
      switch (item) {
        case WS.SPACE:
          return ' ';

        case WS.NEWLINE:
          return '\n';

        case WS.SINGLE_INDENT:
          return this.indentation.getSingleIndent();

        default:
          return item;
      }
    }
  }]);

  return Layout;
}();

exports["default"] = Layout;

var isHorizontalWhitespace = function isHorizontalWhitespace(item) {
  return item === WS.SPACE || item === WS.SINGLE_INDENT;
};
//# sourceMappingURL=Layout.js.map